// Brand & service catalogue constants for Shoolin Digital Services
export const COMPANY = {
  name: "Shoolin Digital Services",
  short: "Shoolin Digital",
  slogan: "Consult. Automate. Grow.",
  tagline:
    "Pune-based digital transformation consultancy. ERP, integrations, websites and print media — engineered for growth.",
  established: "2022",
  phone: "+919284729088",
  phoneDisplay: "+91 92847 29088",
  whatsapp: "919284729088",
  email: "services@shoolindigitalservices.com",
  address: "Pune, Maharashtra, India",
  logo:
    "https://customer-assets.emergentagent.com/job_7f72252b-c138-4e30-9fe4-a617a30a0335/artifacts/7s5c0pxf_Upscaled%20Logo.png",
  wordmark:
    "https://customer-assets.emergentagent.com/job_7f72252b-c138-4e30-9fe4-a617a30a0335/artifacts/18rqo44h_Upscaled%20Name.png",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "why-us", label: "Why Us" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" },
];

export const HERO_STATS = [
  { kpi: "Since", value: "2022" },
  { kpi: "Projects", value: "Multiple" },
  { kpi: "HQ", value: "Pune, IN" },
  { kpi: "Practice", value: "ERP · Web · Print" },
];

export const MARQUEE_KEYWORDS = [
  "NetSuite",
  "Odoo ERP",
  "Celigo",
  "System Integration",
  "Website Engineering",
  "Internet Marketing",
  "Electronics & Print Media",
  "Digital Transformation",
  "Pune · India",
];

export const WHY_US = [
  {
    icon: "Target",
    title: "Outcome-first consulting",
    body:
      "We don't sell licenses. We diagnose the workflow, pick the right stack, and ship the outcome you signed up for.",
  },
  {
    icon: "Zap",
    title: "Automation that compounds",
    body:
      "Every integration we build reduces manual work permanently — so the savings stack month after month.",
  },
  {
    icon: "ShieldCheck",
    title: "ERP + Integration depth",
    body:
      "Certified hands-on with NetSuite, Odoo and Celigo. We've untangled real production stacks across industries.",
  },
  {
    icon: "BarChart3",
    title: "Growth-led marketing",
    body:
      "Websites and campaigns measured on pipeline, not pageviews. Print, digital and electronic media in one team.",
  },
];

export const SHOWCASE_BULLETS = [
  "End-to-end NetSuite & Odoo implementation, migration and roll-outs",
  "Celigo iPaaS integrations between ERP, ecommerce, 3PL and finance",
  "Conversion-engineered marketing websites built on modern stacks",
  "Electronic media, social campaigns and brand-aware print collateral",
  "Pune-based team. Senior consultants. No hand-offs, no off-shoring fog",
];

export const SERVICES = [
  {
    id: "erp",
    slug: "erp",
    tier: "primary",
    category: "Cloud ERP",
    grade: "NetSuite · Odoo",
    weight: "Implementation · Support",
    name: "ERP",
    icon: "Database",
    short:
      "Pick the right ERP, deploy it cleanly, run it without firefighting.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/7f72252b-c138-4e30-9fe4-a617a30a0335/images/b6554d3012ce20075887e860b4f3ef60588104ce5bec4a5af03948cc7acfa588.png",
    tagline: "From spreadsheet chaos to a single operating system.",
    features: [
      "NetSuite implementation",
      "Odoo customisation",
      "ERP migration & data cleanup",
      "Process mapping & SOPs",
      "Post go-live AMS",
    ],
    applications: [
      "Manufacturing & distribution",
      "Multi-entity finance consolidation",
      "Retail & ecommerce back-office",
      "Service businesses scaling past 50+ users",
    ],
    specs: [
      { k: "Platforms", v: "NetSuite, Odoo (Community + Enterprise)" },
      { k: "Modules", v: "Finance, Inventory, Manufacturing, CRM, HR" },
      { k: "Engagement", v: "Discovery → Build → UAT → Cut-over → AMS" },
      { k: "Delivery", v: "On-site Pune + remote across India" },
      { k: "Documentation", v: "BRD, FRS, SOPs, training videos included" },
    ],
  },
  {
    id: "integrations",
    slug: "integrations",
    tier: "primary",
    category: "iPaaS",
    grade: "Celigo Certified",
    weight: "Pre-built + Custom",
    name: "Integrations",
    icon: "Workflow",
    short:
      "Make every system in your stack talk in real-time, without duct tape.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/7f72252b-c138-4e30-9fe4-a617a30a0335/images/0b06b4bbeb12644268ade9d8f7719dabe6e1b89f18ef0f3d40216f73c261ad0b.png",
    tagline: "One source of truth. Zero swivel-chair data entry.",
    features: [
      "Celigo iPaaS implementations",
      "Pre-built ERP ↔ Shopify / Amazon flows",
      "Custom API & webhook integrations",
      "Error-handling & retry frameworks",
      "Monitoring dashboards",
    ],
    applications: [
      "ERP ↔ Ecommerce & marketplace sync",
      "ERP ↔ 3PL / WMS / shipping carrier",
      "Finance automation (banks, payment gateways)",
      "Salesforce / HubSpot ↔ NetSuite",
    ],
    specs: [
      { k: "iPaaS", v: "Celigo integrator.io (certified)" },
      { k: "Protocols", v: "REST, SOAP, GraphQL, SFTP, EDI" },
      { k: "Pattern", v: "Real-time + scheduled batch + event-driven" },
      { k: "Observability", v: "Error queues, alerting, runtime audit" },
      { k: "Hand-off", v: "Documented playbooks + admin training" },
    ],
  },
  {
    id: "website",
    slug: "website",
    tier: "secondary",
    category: "Web Engineering",
    grade: "Design + Build",
    weight: "Marketing · Catalog · Portals",
    name: "Website",
    icon: "Monitor",
    short:
      "Modern, fast, search-friendly websites that turn traffic into pipeline.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/7f72252b-c138-4e30-9fe4-a617a30a0335/images/666b433389546ec44ef639b71d07e4e397b248cdd6966700bfeed1c7f594189e.png",
    tagline: "Pixel-perfect on the front. Performance-engineered underneath.",
    features: [
      "Brand websites & landing pages",
      "Product catalogs & lead capture",
      "Headless CMS & blog setups",
      "SEO, schema & Core Web Vitals",
      "Analytics & conversion tracking",
    ],
    applications: [
      "B2B service & SaaS marketing sites",
      "Product catalogue / brochure sites",
      "Customer / vendor portals",
      "ERP-integrated storefronts",
    ],
    specs: [
      { k: "Stack", v: "React, Next.js, Tailwind, Shadcn UI" },
      { k: "CMS", v: "Strapi, Sanity, WordPress headless" },
      { k: "Hosting", v: "Netlify, Vercel, AWS" },
      { k: "Performance", v: "Lighthouse 90+, fully SEO-ready" },
      { k: "Handover", v: "Editable, documented, training included" },
    ],
  },
  {
    id: "media",
    slug: "electronics-print-media",
    tier: "secondary",
    category: "Media & Brand",
    grade: "Electronics + Print",
    weight: "Campaigns · Collateral",
    name: "Electronics & Print Media",
    icon: "Printer",
    short:
      "Brand storytelling across screens, signage and paper — under one roof.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/7f72252b-c138-4e30-9fe4-a617a30a0335/images/58b8e8a8d1d97e6abd4e6e86545eb4e45f690d00bb8e1dc449c77a04c90b064b.png",
    tagline: "One brand voice across every medium your customer sees.",
    features: [
      "Brand identity & guidelines",
      "Digital & social ad creatives",
      "Brochures, catalogues, packaging",
      "Hoardings, signage & exhibition design",
      "Video & motion creatives",
    ],
    applications: [
      "Product launches & roadshows",
      "Trade-show booths & exhibition kits",
      "Investor & corporate decks",
      "Always-on social & performance creatives",
    ],
    specs: [
      { k: "Print", v: "Brochures, catalogs, packaging, signage, hoardings" },
      { k: "Electronic", v: "Static, animated & video ad creatives" },
      { k: "Tools", v: "Adobe CC, Figma, After Effects" },
      { k: "Distribution", v: "Print partners across Pune & PAN-India" },
      { k: "Output", v: "Print-ready artwork + master files handed over" },
    ],
  },
];
;
